import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React, { useState, useEffect, useRef } from 'react';
import _jsx from '@babel/runtime/helpers/jsx';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { Snackbar } from '@andes/snackbar';
import 'prop-types';
import { recommendationsService, priceSizeByDigits, TrackService, useTrackRecommendations } from '@recommendations-fe/commons';
import { namespaceRecommendations, namespaceCombos } from '@recommendations-fe/commons/namespaces';
import classNames from 'classnames';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.error.cause.js';
import 'core-js/modules/es.promise.js';
import frontendRestclient from 'frontend-restclient';
import CheckboxEl from '@andes/checkbox';
import MoneyAmount from '@andes/money-amount';
import isEmpty from 'lodash/isEmpty';
import 'core-js/modules/es.string.trim.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Image as Image$1 } from 'frontend-image';
import { Button } from '@andes/button';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
const {
  getLab,
  API_PATH,
  FALLBACK_URL
} = recommendationsService;
const defaultClientConfigCombo = {
  baseURL: FALLBACK_URL,
  timeout: 30000,
  sendCSRFToken: false
};
const restclientCombo = frontendRestclient(defaultClientConfigCombo);
const API_COMBO_PATH = "".concat(API_PATH, "/combos");
const API_COMBO_VPP_PATH = '/p/api/combos';
const mapTotalPriceItems = itemSelected => ({
  item_id: itemSelected.main_info.id,
  variation_id: itemSelected.main_info.variation,
  quantity: 1
});
const getComboTotalPrice = (item, combos, siteId) => {
  // Create Content-Type header
  const contentTypeHeader = 'application/json';
  const selected = combos.filter(combo => combo.checkbox.checked).map(mapTotalPriceItems);
  const env = getLab('');
  const enviroment = env ? "&env=".concat(env) : '';
  return restclientCombo.post("/".concat(API_COMBO_PATH, "/total-price?site_id=").concat(siteId).concat(enviroment), {
    headers: {
      'Content-Type': contentTypeHeader
    },
    data: {
      item: mapTotalPriceItems(item),
      selected
    }
  });
};
const addToCartCombo = (item, combos) => {
  const selected = combos.filter(combo => combo.checkbox.checked).map(mapTotalPriceItems);
  const conf = {
    baseURL: '',
    maxRedirects: 0,
    method: 'post',
    responseType: 'json',
    sendCSRFToken: true,
    timeout: 25000
  };
  return frontendRestclient(conf).post("".concat(API_COMBO_VPP_PATH, "/add-to-cart"), {
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      item: mapTotalPriceItems(item),
      selected
    }
  });
};
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const StyledLabel = _ref => {
  let {
    text,
    html_tag: htmlTag,
    class_name: className,
    onClick = null,
    target,
    url,
    id
  } = _ref;
  const Element = id === 'TITLE' ? 'h3' : 'span';
  return /*#__PURE__*/_jsx(Element, {
    className: classNames("".concat(namespaceRecommendations, "-label"), {
      ["".concat(namespaceRecommendations, "-label__").concat(className)]: className
    }),
    onClick: onClick
  }, void 0, htmlTag !== 'a' && url ? /*#__PURE__*/_jsx("a", {
    className: "".concat(namespaceRecommendations, "-link"),
    href: url,
    target: target
  }, void 0, text && text.trim()) : text && text.trim());
};
var Element = StyledLabel;
const getIcon = (icon, namespace, IconFactory) => {
  switch (icon) {
    case 'full_icon':
      return IconFactory(RECOMMENDATIONS_FULL_ICON, "".concat(namespace, "-icon__shipping-fullfilment"));
    default:
      return null;
  }
};
var getIcon$1 = getIcon;
var _br;
const TRANSLATION_TYPE_BREAKPOINT = 'break';
const TRANSLATION_TYPE_ICON = 'ICON';
const INTERPOLATION_REGEXP = /{([\s\S]+?)}/g;

/**
 * @param {string} text
 * @param {object} values
 */
const LabelBuilder = _ref => {
  let {
    values,
    text,
    styles,
    class_name: className,
    html_tag: htmlTag,
    onClick,
    url,
    id,
    target,
    IconFactory
  } = _ref;
  if (isEmpty(values)) {
    return /*#__PURE__*/_jsx(Element, {
      text: text,
      styles: styles,
      class_name: className,
      html_tag: htmlTag,
      onClick: onClick,
      href: url,
      id: id,
      target: target
    });
  }
  const result = text.split(INTERPOLATION_REGEXP);
  for (let index = 0; index < result.length; index += 1) {
    const key = result[index];
    if (Object.prototype.hasOwnProperty.call(values, key)) {
      const replacement = values[key];
      switch (replacement.type) {
        case TRANSLATION_TYPE_ICON:
          result[index] = getIcon$1(replacement.icon_id, namespaceRecommendations, IconFactory);
          break;
        case TRANSLATION_TYPE_BREAKPOINT:
          result[index] = _br || (_br = /*#__PURE__*/_jsx("br", {}));
          break;
        default:
          result[index] = /*#__PURE__*/jsx(Element, _objectSpread({}, replacement));
      }
    } else if (key !== '') {
      result[index] = /*#__PURE__*/React.createElement(Element, {
        text: key
      });
    }
  }
  return /*#__PURE__*/_jsx("p", {
    className: classNames("".concat(namespaceRecommendations, "-label"), {
      ["".concat(namespaceRecommendations, "-label__").concat(className)]: className
    })
  }, void 0, result);
};
var labelBuilder = LabelBuilder;
const mapDecimalSymbol = {
  ',': 'comma',
  '.': 'dot'
};
const Price$1 = _ref => {
  let {
    bold = false,
    className = null,
    from = null,
    original_value = null,
    cross_outed_price = null,
    discount = null,
    subtitle = null,
    installments = null,
    priceSizeOverride = null,
    decimalSeparator = null
  } = _ref;
  const price = {
    symbol: original_value.currency_symbol,
    currencyId: original_value.currency_id,
    fraction: original_value.text,
    cents: original_value.decimal
  };
  const {
    priceSize
  } = priceSizeByDigits(price, priceSizeOverride);
  return /*#__PURE__*/_jsx("div", {
    className: classNames("".concat(namespaceRecommendations, "-price-container"), className, {
      ["".concat(namespaceRecommendations, "-price__").concat(original_value.class_name)]: original_value.class_name
    })
  }, void 0, cross_outed_price && /*#__PURE__*/_jsx(MoneyAmount, {
    value: {
      fraction: cross_outed_price.text,
      cents: cross_outed_price.decimal
    },
    symbol: cross_outed_price.currency_symbol,
    currencyId: cross_outed_price.currency_id,
    centsType: mapDecimalSymbol[decimalSeparator],
    className: classNames("".concat(namespaceRecommendations, "-price__original-value")),
    size: (priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.original) || 12,
    previous: true,
    compact: true
  }), from && labelBuilder(from), /*#__PURE__*/_jsx("div", {
    className: classNames("".concat(namespaceRecommendations, "-price"), {
      ["".concat(namespaceRecommendations, "-price--bold")]: bold
    })
  }, void 0, /*#__PURE__*/_jsx(MoneyAmount, {
    value: {
      fraction: price.fraction,
      cents: price.cents
    },
    symbol: price.symbol,
    currencyId: price.currencyId,
    centsType: "superscript",
    size: priceSize,
    compact: true
  }), discount && /*#__PURE__*/_jsx("span", {
    className: classNames("".concat(namespaceRecommendations, "-price__discount"))
  }, void 0, discount && /*#__PURE__*/jsx(Fragment, {
    children: labelBuilder(discount)
  }))), subtitle && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespaceRecommendations, "-price__subtitle")
  }, void 0, labelBuilder(subtitle)), installments && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespaceRecommendations, "-price__installments")
  }, void 0, labelBuilder(installments)));
};
var Price$2 = Price$1;
const CombosCard = _ref => {
  let {
    classname = '',
    main_info: mainInfo,
    components = [],
    checkbox,
    device = '',
    target = undefined,
    handleClickCheckbox,
    priceSizeOverride,
    IconFactory
  } = _ref;
  const handleClick = e => {
    handleClickCheckbox(e, mainInfo.id);
  };
  const renderComponent = item => {
    var _mainInfo$prices$deci, _mainInfo$prices;
    switch (item.id.toLowerCase()) {
      case 'shipping':
        return /*#__PURE__*/jsx(labelBuilder, _objectSpread({
          class_name: "shipping",
          IconFactory: IconFactory
        }, item));
      case 'price':
        return /*#__PURE__*/jsx(Price$2, _objectSpread(_objectSpread({}, item), {}, {
          priceSizeOverride: priceSizeOverride,
          decimalSeparator: (_mainInfo$prices$deci = mainInfo === null || mainInfo === void 0 || (_mainInfo$prices = mainInfo.prices) === null || _mainInfo$prices === void 0 ? void 0 : _mainInfo$prices.decimal_separator) !== null && _mainInfo$prices$deci !== void 0 ? _mainInfo$prices$deci : '.'
        }));
      default:
        return Element(_objectSpread(_objectSpread({}, item), {}, {
          target
        }));
    }
  };
  const {
    disabled,
    checked
  } = checkbox;
  return /*#__PURE__*/(
    // eslint-disable-next-line react/no-unknown-property
    _jsx("div", {
      className: classNames("".concat(namespaceRecommendations, "-card"), {
        ["".concat(classname)]: classname
      }),
      animated: false
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "-card-content")
    }, void 0, /*#__PURE__*/_jsx(CheckboxEl, {
      disabled: disabled,
      className: "".concat(namespaceRecommendations, "__checkbox"),
      checked: checked,
      onChange: handleClick,
      autoComplete: "off"
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "-card__components-container")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "-card__components")
    }, void 0, components && components.map(item => renderComponent(item))), device === 'mobile' && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "__chevron-container")
    }, void 0, /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "__chevron")
    }, void 0, IconFactory(RECOMMENDATIONS_CHEVRON, "".concat(namespaceRecommendations, "__icon chevron-down")))))))
  );
};
var ComboCard = CombosCard;
const CardContainer = _ref => {
  let {
    state,
    setState,
    createEventData,
    device,
    siteId,
    handleClick,
    showChevron,
    calculate,
    footer,
    priceSizeOverride,
    IconFactory
  } = _ref;
  const getFormattedIntFraction = (price, _ref2) => {
    let {
      main_info: {
        prices
      }
    } = _ref2;
    const rawFraction = Math.floor(price).toString();
    return rawFraction.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, n => "".concat(n).concat(prices.thousand_separator || '.'));
  };
  const getFormattedDecimalFraction = function (price) {
    let forceCents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const fixedStr = price.toFixed(2);
    const decimalPart = fixedStr.split('.')[1];
    if (decimalPart !== '00' || forceCents) {
      return decimalPart;
    }
    return '';
  };
  const calculatePrices = (total, _ref3) => {
    let {
      main_info: {
        prices
      }
    } = _ref3;
    const price = prices ? prices.price : 0;
    return total + price;
  };
  const getFooter = (item, combos) => {
    const selecteds = combos.filter(combo => combo.checkbox.checked);
    const totalCombo = selecteds.reduce(calculatePrices, 0);
    const priceComponent = footer.components.find(component => component.class_name === 'price--total');
    const actionComponent = footer.actions.find(action => action.type === 'ADD-TO-CART');
    const items = selecteds.length + 1;
    const getLabel = (i, component) => {
      const regex = /(\d+)/g;
      const label = i <= 1 ? component.label_singular.replace(regex, items) : component.label_plural.replace(regex, items);
      return label;
    };
    if (priceComponent) {
      const total = calculatePrices(totalCombo, item);
      priceComponent.price.original_price.value = getFormattedIntFraction(total, item);
      priceComponent.price.original_price.decimal = getFormattedDecimalFraction(total);
      priceComponent.label = getLabel(items, priceComponent);
    }
    if (actionComponent) {
      actionComponent.label = getLabel(items, actionComponent);
    }
    return _objectSpread({}, footer);
  };
  const handleClickCheckbox = (e, itemId) => {
    const {
      checked
    } = e.target;
    const combos = state.combos.map(combo => {
      if (combo.main_info.id === itemId) {
        combo.checkbox = _objectSpread(_objectSpread({}, combo.checkbox), {}, {
          checked
        });
      }
      return combo;
    });
    setState(_objectSpread(_objectSpread({}, state), {}, {
      combos
    }));
    const action = 'checked';
    TrackService.checkedCombo(createEventData(action));
    if (!calculate) {
      return getComboTotalPrice(state.item, combos, siteId).then(_ref4 => {
        let {
          data
        } = _ref4;
        return handleClick(data.footer);
      }).catch(() => {});
    }
    return handleClick(getFooter(state.item, combos));
  };
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespaceRecommendations, "-card-container")
  }, void 0, state && state.item && /*#__PURE__*/jsx(ComboCard, _objectSpread(_objectSpread({
    target: "_blank",
    device: device
  }, state.item), {}, {
    priceSizeOverride: priceSizeOverride,
    IconFactory: IconFactory
  })), state && state.combos && state.combos.map(card => /*#__PURE__*/jsx(ComboCard, _objectSpread({
    target: "_blank",
    showChevron: showChevron,
    device: device,
    handleClickCheckbox: handleClickCheckbox,
    priceSizeOverride: priceSizeOverride,
    IconFactory: IconFactory
  }, card))));
};

/**
 * Image Component
 */
class Img extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false
    };
  }
  componentDidMount() {
    // eslint-disable-next-line
    this.setState({
      mounted: true
    });
  }
  render() {
    const {
      lazyLoad,
      src,
      width,
      height,
      src2x,
      alt,
      meta,
      className
    } = this.props;
    const {
      mounted
    } = this.state;
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(className, "__container")
    }, void 0, meta && /*#__PURE__*/_jsx("meta", {
      itemProp: "image",
      content: src
    }), lazyLoad && !mounted ? /*#__PURE__*/_jsx("div", {
      className: className
    }) : /*#__PURE__*/_jsx(Image$1, {
      src: src,
      className: className,
      width: width,
      height: height,
      alt: alt,
      srcSet: src2x ? "".concat(src, " 1x, ").concat(src2x, " 2x") : null
    }));
  }
}
Img.defaultProps = {
  size: null,
  src2x: null,
  title: null,
  meta: false
};

/**
 * Expose Image
 */
var Image = Img;
const Gallery = _ref => {
  let {
    state,
    gallery,
    device,
    imageConfig
  } = _ref;
  const figureSizeClass = device === 'mobile' && state && state.combos.length > 2 ? 'figure-main-reduced' : 'figure-main';
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespaceRecommendations, "-gallery")
  }, void 0, /*#__PURE__*/_jsx("figure", {
    className: "".concat(namespaceRecommendations, "-gallery__").concat(figureSizeClass)
  }, void 0, /*#__PURE__*/_jsx(Image, {
    className: "".concat(namespaceRecommendations, "-gallery__image"),
    src: gallery && gallery.main.picture.url,
    alt: gallery && gallery.main.picture.alt,
    height: gallery && gallery.main.picture.height,
    width: gallery && gallery.main.picture.width,
    lazyLoad: imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.lazyload
  })), gallery.selected && gallery.selected.map(item => /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "".concat(namespaceRecommendations, "-gallery__plus")
    }, void 0, "+"), /*#__PURE__*/_jsx("figure", {
      className: "".concat(namespaceRecommendations, "-gallery__").concat(figureSizeClass)
    }, void 0, /*#__PURE__*/_jsx("a", {
      href: item.permalink,
      target: "_blank",
      rel: "noreferrer"
    }, void 0, /*#__PURE__*/_jsx(Image, {
      className: "".concat(namespaceRecommendations, "-gallery__image"),
      src: item && item.picture.url,
      alt: item.picture.alt,
      height: item && item.picture.height,
      width: item && item.picture.width,
      lazyLoad: imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.lazyload
    }, "".concat(item.id, "--image"))))]
  })));
};
const getFormattedIntFraction = function () {
  let price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let separator = arguments.length > 1 ? arguments[1] : undefined;
  const rawFraction = price.toString();
  return rawFraction.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, n => "".concat(n).concat(separator));
};
const getFormattedIntCents = function () {
  let price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  const priceStr = price.toString();
  return priceStr.length > 1 ? priceStr : "0".concat(priceStr);
};
const namespace = 'ui-combos-label';
const Price = _ref => {
  let {
    original_price: originalPrice,
    original_value: originalValue,
    decimal,
    discount,
    priceSizeOverride
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [originalPrice && /*#__PURE__*/_jsx(MoneyAmount, {
      value: {
        fraction: getFormattedIntFraction(originalPrice.value, '.') || 0,
        cents: originalPrice.decimal ? getFormattedIntCents(originalPrice.decimal) : null
      },
      symbol: originalPrice.currency_symbol,
      currencyId: originalPrice.currency_id,
      centsType: "superscript",
      size: (priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.price) || 16,
      compact: true
    }), originalValue && /*#__PURE__*/_jsx(MoneyAmount, {
      value: {
        fraction: originalValue.text,
        cents: decimal
      },
      symbol: originalValue.currency_symbol,
      currencyId: originalValue.currency_id,
      centsType: "superscript",
      size: (priceSizeOverride === null || priceSizeOverride === void 0 ? void 0 : priceSizeOverride.price) || 16,
      compact: true
    }), discount && /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "__discount")
    }, void 0, discount.text.trim())]
  });
};
const PriceContainer = _ref => {
  let {
    components,
    priceSizeOverride,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(className, "__shipping")
  }, void 0, components && components.map(component => /*#__PURE__*/_jsx("span", {
    className: "".concat(className, "__").concat(component.class_name)
  }, component.type, /*#__PURE__*/_jsx("span", {
    className: "".concat(className, "-label")
  }, void 0, component.label || component.label_plural, component.shipping && /*#__PURE__*/_jsx("span", {
    className: "".concat(className, "-label-shipping")
  }, void 0, component.shipping), ":"), component.price && /*#__PURE__*/jsx(Price, _objectSpread({
    priceSizeOverride: priceSizeOverride
  }, component.price)), component.extra_data && /*#__PURE__*/_jsx("span", {
    className: "".concat(className, "__").concat(component.class_name, "__extra-data")
  }, void 0, component.extra_data))));
};
const ActionContainer = _ref => {
  let {
    actions,
    size,
    className
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(className, "__actions")
  }, void 0, actions && actions.map(action => /*#__PURE__*/_jsx(Button, {
    className: action.class_name,
    hierarchy: action.hierarchy,
    size: size,
    type: "submit"
  }, action.type, /*#__PURE__*/_jsx("span", {}, void 0, action.label || action.label_plural))));
};
const Combos = _ref => {
  let {
    apiResponse,
    size,
    device,
    priceSizeOverride,
    IconFactory,
    shouldRaiseErrors,
    showVariationsError,
    className
  } = _ref;
  const {
    title,
    gallery,
    footer,
    track,
    classname,
    calculate,
    site_id: siteId,
    variation_id: variationId,
    image_config: imageConfig,
    recommendation_info: recommendationInfo
  } = apiResponse;
  const {
    recommendations
  } = recommendationInfo;
  const [state, setState] = useState({
    item: recommendations && recommendations[0],
    combos: recommendations && recommendations.filter(combo => {
      var _combo$classname;
      return !(combo !== null && combo !== void 0 && (_combo$classname = combo.classname) !== null && _combo$classname !== void 0 && _combo$classname.includes('ui-combos-card-feature'));
    })
  });
  const DEFAULT_DELAY_TIME = 3000;
  const SNACKBAR_COLOR = {
    ERROR: 'red',
    SUCCESS: 'green'
  };
  const ACTION = 'p/api/combos/add-to-cart';
  const [galleryState, setGallery] = useState(gallery);
  const [footerState, setFooter] = useState(footer);
  const [message, setMessage] = useState(null);
  const handleMessage = (msg, type) => {
    setMessage({
      text: msg,
      type
    });
    setTimeout(() => {
      setMessage(null);
    }, DEFAULT_DELAY_TIME);
  };
  const handleClickCheckbox = f => {
    setFooter(_objectSpread({}, f));
  };
  const createItemChecked = item => {
    if (!item) {
      return {};
    }
    const price = item.components.find(i => i.type === 'PRICE');
    return {
      currency_id: price.currency_symbol,
      price: price.original_value.text,
      item: {
        id: item.main_info.id,
        category_id: item.main_info.category_id,
        variation: item.main_info.variation
      },
      quantity: 1
    };
  };
  const createEventData = () => {
    const slected = state.combos.filter(combo => combo.checkbox.checked);
    const items = slected.map(createItemChecked);
    const images = gallery.selected.filter(image => slected.find(item => item.main_info.id === image.id));
    setGallery(_objectSpread(_objectSpread({}, gallery), {}, {
      selected: images
    }));
    const eventData = {
      event_data: {
        backend_id: track.event_data.backend_id,
        client: track.event_data.client,
        item: state.item.main_info.id,
        variation: state.item.main_info.variation,
        items,
        quantity: items.length + 1
      },
      experiment: track.experiment,
      experiments: track.experiments
    };
    return eventData;
  };
  const addToCartAction = e => {
    e.preventDefault();
    const meta = document.querySelector('meta[name="csrf-token"]');
    if (meta) {
      meta.content;
    } else {
      // eslint-disable-next-line no-console
      console.log('no existe meta csrf-token');
    }

    // eslint-disable-next-line no-undef
    if (shouldRaiseErrors) {
      showVariationsError(device, 'APPLAY');
      if (device !== 'desktop') {
        return;
      }
    }
    addToCartCombo(state.item, state.combos).then(_ref2 => {
      let {
        data
      } = _ref2;
      TrackService.addToCartCombo(createEventData());
      window.location = data.cart_url;
    }).catch(err => {
      handleMessage(err.response.data.displayMessage, SNACKBAR_COLOR.ERROR);
    });
  };
  const renderCardContainer = fromDevice => /*#__PURE__*/_jsx(CardContainer, {
    state: state,
    setState: setState,
    createEventData: createEventData,
    siteId: siteId,
    handleClick: handleClickCheckbox,
    device: device,
    showChevron: fromDevice === 'mobile',
    footer: footer,
    calculate: calculate,
    priceSizeOverride: priceSizeOverride,
    IconFactory: IconFactory
  });
  useEffect(() => {
    setState({
      item: recommendations && recommendations[0],
      combos: recommendations && recommendations.filter(combo => {
        var _combo$classname2;
        return !(combo !== null && combo !== void 0 && (_combo$classname2 = combo.classname) !== null && _combo$classname2 !== void 0 && _combo$classname2.includes('ui-combos-card-feature'));
      })
    });
    setGallery(gallery);
    setFooter(footer);
  }, [variationId, footer, gallery, recommendations]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames(namespaceCombos, className, classname)
    }, void 0, /*#__PURE__*/_jsx("form", {
      onSubmit: addToCartAction,
      action: ACTION,
      method: "POST"
    }, void 0, /*#__PURE__*/_jsx("h2", {
      className: "".concat(namespaceRecommendations, "__title")
    }, void 0, title), galleryState && /*#__PURE__*/_jsx(Gallery, {
      state: state,
      gallery: galleryState,
      device: device,
      imageConfig: imageConfig
    }), /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "-container")
    }, void 0, renderCardContainer(device), footerState && /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceRecommendations, "-footer")
    }, void 0, footerState.components && /*#__PURE__*/_jsx(PriceContainer, {
      components: footerState.components,
      priceSizeOverride: priceSizeOverride,
      className: "".concat(namespaceRecommendations, "-footer")
    }), footerState.actions && /*#__PURE__*/_jsx(ActionContainer, {
      actions: footerState.actions,
      size: size,
      className: "".concat(namespaceRecommendations, "-footer")
    }))))), message && message.text && /*#__PURE__*/_jsx(Snackbar, {
      delay: DEFAULT_DELAY_TIME,
      message: message.text,
      color: message.type,
      show: true
    })]
  });
};
var Combos$1 = Combos;
const priceSizeOverride$1 = {
  price: 18,
  discount: 12,
  installments: 14,
  original: 12
};
const CombosDesktop = props => /*#__PURE__*/jsx(Combos$1, _objectSpread({
  device: "desktop",
  size: "medium",
  priceSizeOverride: priceSizeOverride$1
}, props));
var CombosDesktop$1 = CombosDesktop;
const priceSizeOverride = {
  price: 16,
  discount: 12,
  installments: 14,
  original: 12
};
const CombosMobile = props => /*#__PURE__*/jsx(Combos$1, _objectSpread({
  device: "mobile",
  size: "large",
  priceSizeOverride: priceSizeOverride
}, props));
var CombosMobile$1 = CombosMobile;
const _excluded = ["runCatchErrorBoundary"];
const withCombosContainer = WrappedCombos => {
  const CombosContainer = _ref => {
    let {
        runCatchErrorBoundary = () => {}
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    try {
      const {
        apiResponse
      } = props;
      const {
        track
      } = apiResponse;

      // Make a desktop comparator ref for IO
      const combosContainerRef = useRef();

      // Tracks when the combos is printed and is on the viewport
      useTrackRecommendations({
        combosContainerRef,
        trackData: track,
        shouldTrackOnView: true,
        trackingFunction: TrackService.viewCombos
      });
      return /*#__PURE__*/jsx("section", {
        id: track.event_data.client,
        ref: combosContainerRef,
        className: "".concat(namespaceCombos, "-wrapper-ref"),
        children: /*#__PURE__*/jsx(WrappedCombos, _objectSpread({}, props))
      });
    } catch (error) {
      return runCatchErrorBoundary(error);
    }
  };
  return CombosContainer;
};
var withCombosContainer$1 = withCombosContainer;
class RecommendationsAddToCart {
  static addToCart(req, res, context, restclient) {
    const url = '/frontend/carts/items/add';
    const data = {
      item_id: req.body.item_id,
      site_id: req.body.site_id || req.body.item_id.substring(0, 3),
      context: req.body.context || 'recommendations',
      quantity: req.body.quantity || '1',
      user_id: req.user.id,
      flow_type: 'mercadolibre',
      mode: 'page'
    };
    const params = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, res.locals.restclient.params), req.params), req.query), {}, {
      user_id: req.user.id,
      'caller.id': req.user.id,
      site_id: req.body.site_id || req.body.item_id.substring(0, 3),
      item_id: req.body.item_id
    });
    const {
      headers
    } = res.locals.restclient;
    return restclient.post(url, {
      data,
      params,
      headers,
      context
    });
  }
}
var RecommendationsAddToCart$1 = RecommendationsAddToCart;
const RecommendationsCombosDesktop = withCombosContainer$1(CombosDesktop$1);
const RecommendationsCombosMobile = withCombosContainer$1(CombosMobile$1);
export { RecommendationsAddToCart$1 as RecommendationsAddToCart, RecommendationsCombosDesktop, RecommendationsCombosMobile };
